import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import ChipsDropDown from '../components/ChipsDropDown';
import { ProductsContext } from '../../ProductsContext';
import { BigDownArrowIcon } from 'assests/GmsIcons';
import CategoryDropDown from '../components/CategoryDropDown';
import ConfirmDialog from 'Pages/GMS/ISR/Components/ConfirmDialog';


type TSelectTarget = {
  selectedProducts: TOption[],
  setSelectedProducts: Dispatch<SetStateAction<TOption[]>>
  payload: TRecategorizePayload
  setPayload: Dispatch<SetStateAction<TRecategorizePayload>>
}

const SelectTarget = ({ selectedProducts, setSelectedProducts, payload, setPayload }: TSelectTarget) => {
  const prodContext = useContext(ProductsContext)
  const handleCategorySelect = (id: string) => {
    const catObjArr = prodContext?.categoryData?.flatMap(x => x?.category || [])?.find(y => y?.id === id)
    setPayload((prev: any) => {
      const newState = {
        ...prev,
        target_category: id,
        target_category_name: catObjArr ? catObjArr?.name : null
      }
      return newState
    })
  }

  const [showComfirmDialog, setShowComfirmDialog] = useState(false)
  const [selectedId, setSelectedId] = useState<string | null>(null)

  /*
   * Takes the chosen id directly since `CategoryDropDown` became a DS `Dropdown`
   * (2026-09-13). The GATE is unchanged: a target already set means confirm first,
   * because switching it discards steps 2 and 3.
   *
   * `e.persist()` is gone with the event — it was a React 16 pooling workaround and
   * has been a no-op since 17.
   */
  const handleConfirmSelect = (categoryId: string) => {
    setSelectedId(categoryId)
    if (payload?.target_category) {
      setShowComfirmDialog(true)
    }
    else {
      handleCategorySelect(categoryId)
    }
  }

  return (
    /*
     * ONE width, on the column. This step's three controls were sized independently:
     * the chips box had a `w-[400px]` wrapper, the read-only source was `w-full` of
     * whatever that made the column, and the target picker sat in a `tw-flex` wrapper —
     * which made it a flex ITEM and shrink-wrapped it to its own label, so it rendered
     * visibly narrower than the two above it (reported 2026-09-13).
     *
     * The 400px moves up here unchanged, so the first two measure exactly as before and
     * the third now joins them.
     */
    <div className='tw-w-[400px]'>
      <div className="tw-text-ink tw-mb-2 tw-text-sm tw-font-medium">Products to be recategorized</div>
      <div>
      <ChipsDropDown
        header='Products Selected'
          options={selectedProducts}
          setOptions={setSelectedProducts}
          remove={true}
      />
      </div>
      <div>
        <div className="tw-text-ink tw-mt-6 tw-mb-2 tw-text-sm tw-font-medium">(From) Source</div>
        <div className={` tw-w-full tw-text-ink-disabled tw-text-sm tw-h-9 tw-px-2.5 tw-py-2  tw-rounded tw-border tw-border-edge tw-bg-surface-sunken`}>
          {prodContext?.selected_Category?.name}
      </div>
      </div>
      <div className='tw-mt-2'>
        <BigDownArrowIcon />
      </div>
      <div>
        <div className="tw-text-ink tw-mt-2 tw-mb-2 tw-text-sm tw-font-medium">(To) Target</div>
        <CategoryDropDown value={payload?.target_category} handleSelect={handleConfirmSelect} />
      </div>
      {showComfirmDialog ?
        <ConfirmDialog id='target-category-change' title={'Change target category?'}
          message={'By changing target you will loose the data set in step 2 and step 3, Do you still want to continue?'}
          onClose={() => {
            setShowComfirmDialog(false);
          }}
          onConfirm={() => {
            if (selectedId) {
              handleCategorySelect(selectedId)
              setShowComfirmDialog(false);
            }
          }} />
        : null}
    </div>
  )
}

export default SelectTarget;